/* Tour "entities-consolidation" — étapes pour consolider une seconde entité depuis le Dashboard. */

import './types';

window.FygrTour.register('entities-consolidation', {
  title: 'Consolider ses comptes',
  steps: [
    {
      target: '[data-tour-step="comptes-pill"]',
      badge: 'Étape 1 / 3',
      title: 'Ouvrez le menu Comptes',
      body: 'Cliquez sur « Comptes » pour ouvrir la liste de vos entités et accéder à la consolidation.',
      placement: 'bottom-start',
      waitFor: '[data-tour-step="consolider-trigger"]',
    },
    {
      target: '[data-tour-step="consolider-trigger"]',
      badge: 'Étape 2 / 3',
      title: 'Activez la consolidation',
      body: 'Cliquez sur « Consolider plusieurs entités » : toutes vos entités seront sélectionnées par défaut.',
      placement: 'right-start',
      waitFor: '[data-tour-step="valider-btn"]',
    },
    {
      target: '[data-tour-step="valider-btn"]',
      badge: 'Étape 3 / 3',
      title: 'Validez la consolidation',
      body: 'Cliquez sur « Valider » pour appliquer et voir vos entités fusionnées.',
      placement: 'right',
    },
  ],
  celebration: {
    title: 'Vos comptes sont consolidés !',
    body: 'Vous voyez maintenant vos entités fusionnées dans votre dashboard.',
    followup: {
      title: 'Vos entités sont consolidées !',
      body: 'Explorez votre dashboard, ou revenez dans Modules pour compléter d\'autres tutoriels.',
    },
  },
  onExit: () => {
    if (window.location.pathname !== '/guide') {
      window.location.href = '/guide';
    }
  },
});

export {};
